import { render } from "./GeneralSection.vue?vue&type=template&id=76b3dd00&scoped=true"
import script from "./GeneralSection.vue?vue&type=script&lang=js"
export * from "./GeneralSection.vue?vue&type=script&lang=js"

import "./GeneralSection.vue?vue&type=style&index=0&id=76b3dd00&scoped=true&lang=css"

import exportComponent from "../../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76b3dd00"]])

export default __exports__